import { render, staticRenderFns } from "./CardAddressDetails.vue?vue&type=template&id=84f575ac&"
import script from "./CardAddressDetails.vue?vue&type=script&lang=js&"
export * from "./CardAddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardAddressDetails.vue?vue&type=style&index=0&id=84f575ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports